import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import rootRoutes from '@/modules/root/routes'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import AppProvider from './components/AppProvider'
import * as Sentry from '@sentry/react'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import 'flex-render/css'
import './index.css'
import { setDefaultOptions } from 'date-fns'
import th from 'date-fns/locale/th'

Sentry.init({
	dsn: 'https://c1ecc12e56aac88bb8a02cab879aae01@o4509758630920192.ingest.us.sentry.io/4509979681161216',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	release: import.meta.env.VITE_RELEASE,
	environment: import.meta.env.VITE_ENV || 'development',
})

Sentry.setTag('provider', import.meta.env.VITE_SENTRY_PROVIDER)

setDefaultOptions({
	locale: th,
})

const router = createBrowserRouter(rootRoutes)

createRoot(document.getElementById('root')!).render(
	<NuqsAdapter>
		<AppProvider>
			<RouterProvider router={router} />
		</AppProvider>
	</NuqsAdapter>,
)
